module.exports = __webpack_public_path__ + "static/img/yael-avatar@3x.ace9c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cx-avatars/yael-avatar@3x.png
// module id = Tfbv
// module chunks = 6